var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.262776 11.1222C0.273774 11.4907 0.306768 11.7656 0.323265 11.8976C0.345261 12.0351 0.471739 12.1725 0.614714 12.2C0.63671 12.2 0.658706 12.2055 0.680703 12.2055C0.807181 12.2055 0.928159 12.1395 0.994148 12.0296C3.49621 7.8448 7.18607 8.03176 8.35186 8.20773V11.0452C8.35186 11.1827 8.43985 11.3092 8.56633 11.3587C8.6928 11.4082 8.84128 11.3752 8.93476 11.2762L13.125 6.72299C13.576 6.23358 13.565 5.48021 13.1085 5.00179L8.7313 0.432091C8.63781 0.333108 8.48934 0.300114 8.36286 0.355104C8.23638 0.404595 8.1539 0.531073 8.1539 0.668549V3.44556C7.63149 3.44556 7.18057 3.50605 6.72965 3.57204C2.95181 4.07795 0.174791 7.33338 0.262776 11.1222ZM8.82478 3.77551V1.4989L12.6301 5.46371C12.8446 5.68367 12.8501 6.03561 12.6411 6.26657L9.03924 10.1874V7.93278C9.03924 7.77881 8.93476 7.64133 8.78079 7.60834C8.78079 7.60834 8.26938 7.48736 7.47752 7.48736C5.95428 7.48736 3.10578 7.93828 0.944657 10.9133C0.966653 7.54235 3.46322 4.69385 6.82863 4.23193C7.38953 4.15494 7.86245 4.09995 8.48934 4.11645H8.49484C8.58832 4.11645 8.66531 4.08895 8.7313 4.02296C8.79729 3.95697 8.83578 3.87449 8.83578 3.78101L8.82478 3.77551Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.d598b172e4193021ff28ce908072ece3.svg";
export { ForwardRef as ReactComponent };